<template>
    <div class="md:ppv2-w-[80%] ppv2-w-full">
        <form @submit.prevent="save">
            <div class="section-block mb-6 overflow-hidden !p-0">
                <div>
                    <span class="poppinsSemiBold ppv2-text-gray-700 dark:ppv2-text-gray-200">
                        {{ $t('website_settings.mobile_intro.screen_section') }}
                    </span>
                </div>
                <div class="ppv2-p-6">
                    <div class="ppv2-flex ppv2-flex-col">
                        <!-- Name and Description Column -->
                        <!-- Name -->
                        <div class="ppv2-mb-4">
                            <CustomInput
                                v-model="formData.name"
                                :label="$t('website_settings.mobile_intro.name_label')"
                                :required="true"
                                :placeholder="$t('website_settings.mobile_intro.name_placeholder')"
                            />
                        </div>

                        <!-- Description -->
                        <div class="ppv2-mb-4">
                            <BaseTextarea
                                v-model="formData.description"
                                :label="$t('website_settings.mobile_intro.description_label')"
                                :use-editor="false"
                                :rows="4"
                                :placeholder="$t('website_settings.mobile_intro.description_placeholder')"
                            />
                        </div>

                        <!-- Image Column -->
                        <div class="ppv2-mb-4">
                            <CustomInputUpload
                                v-model="formData.image_url"
                                @input="onImageSelected"
                                :label="$t('website_settings.mobile_intro.image_label')"
                                specificTaille="275x275px"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import CustomInput from '../../../../Inputs/CustomInput.vue'
import BaseTextarea from '../../../../Shared/BaseTextarea.vue'
import BaseButton from '../../../../Shared/BaseButton.vue'
import CustomInputUpload from '../../../../Inputs/CustomInputUpload.vue'

export default {
    name: 'TabMobileIntro',
    components: {
        CustomInput,
        BaseTextarea,
        BaseButton,
        CustomInputUpload,
    },
    props: {
        data: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            saving: false,
            formData: {
                id: null,
                name: '',
                description: '',
                image: null, // base64 string
                image_url: null, // preview URL
            },
        }
    },
    mounted() {
        this.loadData()
        this.$root.$on('website-settings-trigger-save-mobile_intro', this.save)
    },
    beforeDestroy() {
        this.$root.$off('website-settings-trigger-save-mobile_intro', this.save)
    },
    methods: {
        async loadData() {
            try {
                const response = await axios.get('/back-office/mobile-app-intro')
                const items = response.data || []

                // Only take the first item (single screen)
                if (items.length > 0) {
                    this.formData = {
                        id: items[0].id,
                        name: items[0].name || '',
                        description: items[0].description || '',
                        image: null,
                        image_url: items[0].image_url || null,
                    }
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },
        onImageSelected(file) {
            if (file) {
                // Read file as base64 for backend
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.formData.image = e.target.result // base64 string
                }
                reader.readAsDataURL(file)
            } else {
                this.formData.image = null
                this.formData.image_url = null
            }
        },
        async save() {
            this.saving = true
            try {
                // Build items array with image as base64 (backend expects this format)
                const item = {
                    id: this.formData.id,
                    name: this.formData.name,
                    description: this.formData.description,
                }

                // Add base64 image if available
                if (this.formData.image) {
                    item.image = this.formData.image
                }

                const mobileResponse = await axios.post('/back-office/mobile-app-intro/', {
                    items: [item], // Array of items
                    removedItemsIds: [], // Array of IDs
                })

                this.$emit('save', { loading: false, success: true, message: mobileResponse.data?.message })
            } catch (error) {
                this.$toast.error(error.response.data.message)
                this.$emit('save', { loading: false })
            } finally {
                this.saving = false
            }
        },
    },
}
</script>

<style scoped>
.section-block {
    border-radius: 20px;
    padding: 24px;
    box-shadow:
        0 4px 6px -1px rgba(0, 0, 0, 0.1),
        0 2px 4px -1px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(0, 0, 0, 0.05);
}

.dark .section-block {
    border-color: rgba(255, 255, 255, 0.05);
}
</style>
